import React from 'react';
import './Eingabe.css';
import { FormattedMessage } from "react-intl";
import EingabeAnzahlKulissen from "./EingabeAnzahlKulissen";
import EingabeKulissenbreite from "./EingabeKulissenbreite";
import EingabeKulissentyp from "./EingabeKulissentyp";
import Schalldaempfer from "../schalldaempfer/Schalldaempfer";
import EingabeDruckbereich from "./EingabeDruckbereich";
import EingabeAnschlussprofil from "./EingabeAnschlussprofil";
import EingabeZusatzoptionen from "./EingabeZusatzoptionen";
import { getPdfDisplayFileName, isValidWindowsPdfFileName } from "../utils/windowsFileName";
import { parseSchalldaempferConfig, serializeSchalldaempferConfig, buildShareUrl } from "../utils/eingabeUrlState";

class Eingabe extends React.Component {
   constructor(props) {
    super(props);
    // Eingabezustand aus der URL wiederherstellen (Issue #43). Fehlende oder
    // ungueltige Parameter fallen auf die bisherigen Defaults zurueck, sodass
    // das Verhalten ohne Parameter unveraendert bleibt.
    const urlConfig = parseSchalldaempferConfig(
        typeof window !== "undefined" && window.location ? window.location.search : ""
    );
    this.state = {
        kanallaenge: urlConfig.kanallaenge,
        kanalhoehe: urlConfig.kanalhoehe,
        kanalbreite: urlConfig.kanalbreite,
        volumenstrom: urlConfig.volumenstrom,
        selectedKulissenbreite: urlConfig.selectedKulissenbreite,
        selectedKulissentyp: urlConfig.selectedKulissentyp,
        selectedKulissenanzahl: urlConfig.selectedKulissenanzahl,
        einfugedaempfung : [],
        selectedDruckbereich: urlConfig.selectedDruckbereich,
        selectedAnschlussprofil: urlConfig.selectedAnschlussprofil,
        calculatedAnschlussprofil: urlConfig.selectedAnschlussprofil,
        checkedAnschlussprofil: urlConfig.checkedAnschlussprofil,
        filter32hz : 0,
        filter63hz : 0,
        filter125hz :0,
        filter250hz :0,
        filter500hz :0,
        filter1000hz :0,
        filter2000hz :0,
        filter4000hz :0,
        filter8000hz :0,
        rabatt: urlConfig.rabatt,
        pdfFileName: "",
        pdfFileNameManuallyChanged: false,
        linkKopiert: false,

        optionen: [
            {id: 1, value:<FormattedMessage id="Kulissen_in_Folie" />, isChecked: urlConfig.optionenChecked[0]},
            {id: 2, value:<FormattedMessage id="Fuehrungsschienen_im_Kanal" />, isChecked: urlConfig.optionenChecked[1]},
            {id: 3, value:<FormattedMessage id="Anstroemkalotten_einseitig_V_Form" />, isChecked: urlConfig.optionenChecked[2]},
        ],
        // optionen: [
        //     {id: 1, value:"Kulissen in Folie (für fetthaltige Luft)", isChecked: false},
        //     {id: 2, value:"Führungsschienen im Kanal (für Kulissen lose und revisionierbar)", isChecked: false},
        //     {id: 3, value:"Anströmkalotten einseitig V-Form", isChecked: false},
        // ],

        //kulissenanzahl : 1,
    };
    this.handleInputChange= this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSelectedKulissenbreiteHandler = this.getSelectedKulissenbreiteHandler.bind(this);
    this.getSelectedKulissentypHandler = this.getSelectedKulissentypHandler.bind(this);
    this.getSelectedKulissenanzahlHandler = this.getSelectedKulissenanzahlHandler.bind(this);
    this.getSelectedDruckbereichHandler = this.getSelectedDruckbereichHandler.bind(this);
    this.getEinfuegedaempfungHandler = this.getEinfuegedaempfungHandler.bind(this);
    this.getSelectedAnschlussprofilHandler = this.getSelectedAnschlussprofilHandler.bind(this);
    this.getCalculatedAnschlussprofilHandler = this.getCalculatedAnschlussprofilHandler.bind(this);
    this.getCheckedAnschlussprofilHandler = this.getCheckedAnschlussprofilHandler.bind(this);
    this.getFilterwertHandler = this.getFilterwertHandler.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.handlePdfFileNameChange = this.handlePdfFileNameChange.bind(this);
    this.handlePdfFileNameKeyDown = this.handlePdfFileNameKeyDown.bind(this);
    this.copyShareLink = this.copyShareLink.bind(this);
  }
  data = []

    async componentDidMount(){


       const request = await fetch('../daten.csv');
       const datastring = await request.text();
       // console.log('Daten: ' + datastring.toString());
        let arr = datastring.split('\r');
        var jsonObj = [];
        var headers = arr[0].split(';');
        for(var i = 1; i < arr.length; i++) {
            var data = arr[i].split(';');
            var obj = {};

            for(var j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj);
        }
        JSON.stringify(jsonObj);
        // console.log(jsonObj);
        // console.log("Nr.: "+jsonObj[0]["125"]);
        var daten = [];
        daten = this.csvJSON(datastring);
        this.data = this.csvJSON(datastring);
        this.getEinfuegedaempfungHandler(daten);


  }

  componentDidUpdate() {
      this.syncUrl();
  }

  // Aktuelle Eingabe-Konfiguration (nur technische Parameter) fuer URL/Link.
  currentConfig() {
      return {
          kanalbreite: this.state.kanalbreite,
          kanalhoehe: this.state.kanalhoehe,
          kanallaenge: this.state.kanallaenge,
          volumenstrom: this.state.volumenstrom,
          selectedKulissentyp: this.state.selectedKulissentyp,
          selectedKulissenbreite: this.state.selectedKulissenbreite,
          selectedKulissenanzahl: this.state.selectedKulissenanzahl,
          selectedDruckbereich: this.state.selectedDruckbereich,
          selectedAnschlussprofil: this.state.selectedAnschlussprofil,
          checkedAnschlussprofil: this.state.checkedAnschlussprofil,
          rabatt: this.state.rabatt,
          optionenChecked: this.state.optionen.map((option) => option.isChecked),
      };
  }

  // Haelt die Adressleiste mit der aktuellen Konfiguration synchron (fuer
  // Lesezeichen) - nur Query-Params, ohne neue History-Eintraege.
  syncUrl() {
      if (typeof window === "undefined" || !window.history || !window.location) {
          return;
      }
      const query = serializeSchalldaempferConfig(this.currentConfig());
      const newUrl = `${window.location.pathname}?${query}`;
      if (`${window.location.pathname}${window.location.search}` !== newUrl) {
          window.history.replaceState(null, "", newUrl);
      }
  }

  async copyShareLink() {
      const query = serializeSchalldaempferConfig(this.currentConfig());
      const url = buildShareUrl(query);
      try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(url);
          } else {
              const textarea = document.createElement("textarea");
              textarea.value = url;
              textarea.setAttribute("readonly", "");
              textarea.style.position = "absolute";
              textarea.style.left = "-9999px";
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand("copy");
              document.body.removeChild(textarea);
          }
          this.setState({ linkKopiert: true });
          window.setTimeout(() => this.setState({ linkKopiert: false }), 2000);
      } catch (error) {
          // Kein Absturz, falls die Zwischenablage nicht verfuegbar ist.
      }
  }

  csvJSON(csv){
        let arr = csv.split('\r');
        var jsonObj = [];
        var headers = arr[0].split(';');
        for(var i = 1; i < arr.length; i++) {
            var data = arr[i].split(';');
            var obj = {};

            for(var j = 0; j < data.length; j++) {
                obj[headers[j].trim()] = data[j].trim();
            }
            jsonObj.push(obj);
        }
        JSON.stringify(jsonObj);
        return jsonObj;
}
 getEinfuegedaempfungHandler(data) {

       this.setState((state) => {
           return {einfugedaempfung: data}
       });
  }


  getSelectedKulissenbreiteHandler(data) {

       this.setState((state) => {
           return {selectedKulissenbreite: data}
       });
  }
  getSelectedKulissentypHandler(data) {

       this.setState((state) => {
           return {selectedKulissentyp: data}
       });
  }
  getSelectedKulissenanzahlHandler(data) {

       this.setState((state) => {
           return {selectedKulissenanzahl: data}
       });
  }
  getSelectedDruckbereichHandler(data) {

       this.setState((state) => {
           return {selectedDruckbereich: data}
       });
  }
  getSelectedAnschlussprofilHandler(data){

       this.setState((state) => {
           return {selectedAnschlussprofil: data}
       });

  }
  getCalculatedAnschlussprofilHandler(data){

       if(this.state.checkedAnschlussprofil){
           if(this.state.calculatedAnschlussprofil !== data) {
           this.setState((state) => {
               return {calculatedAnschlussprofil: data}
           });
       }
       }
       else if(this.state.selectedAnschlussprofil !== data){
           this.setState({selectedAnschlussprofil: data, calculatedAnschlussprofil:data})
       }


  }

  getCheckedAnschlussprofilHandler(data){
       // console.log('Event Handle parent');
       this.setState((state) => {
           return {checkedAnschlussprofil: data}
       });

  }
  getFilterwertHandler(event){
       const target = event.target;
      if(target.value !== ""){
          // console.log("Enter!")
          const value = target.name === 'isGoing' ? target.checked : target.value;
          const name = target.name;
          this.setState({
              [name]: value    });
      }
    // const value = target.name === 'isGoing' ? target.checked : target.value;
    // const name = target.name;
    // this.setState({
    //   [name]: value    });
    // console.log('Name:' + this.state.name);
    // console.log('Target-Name:' + target.name);
    // console.log('Target-value:' + target.value);
  }

    handleCheckChieldElement = (event) => {
        let optionen = this.state.optionen
        // console.log("Option ID Change: " + event.target.value);
        // console.log("Option ID Change: " + event.target.id);
        // if(event.target.value == "Kulissen in Folie"){
        //     console.log("Option ID Change: " + event.target.value);
        //     this.getSelectedKulissentypHandler('HKL');
        // }
        // Kulissen in Folie = HKL
        if(Number(event.target.id) === 1){
            // console.log("Option ID Change: " + event.target.value);
            this.getSelectedKulissentypHandler('HKL');
        }
        // optionen[0].isChecked = event.target.checked;

        optionen.forEach(option => {
            // console.log("Optionen: " + option.id+ " " + event.target.id);
            // console.log("Optionen-target-id: "+ event.target.id);
            if (option.id === Number(event.target.id)) {
                // console.log("Optionen: " + event.target.value + " geändert");
                option.isChecked = event.target.checked;
            }
        })
        this.setState({optionen: optionen})
    }



  handleInputChange(event) {

    const target = event.target;
      if(target.value !== ""){
          const value = target.name === 'isGoing' ? target.checked : target.value;
          const name = target.name;
          this.setState({
              [name]: value    });
      }

    // console.log('Name:' + this.state.name);
    // console.log('Target-Name:' + target.name);
    // console.log('Target-value:' + target.value);
  }

  getCurrentBestellschluessel() {
      const kulissenspaltbreite = ((parseFloat(this.state.kanalbreite) - (parseFloat(this.state.selectedKulissenanzahl) * parseFloat(this.state.selectedKulissenbreite))) / parseFloat(this.state.selectedKulissenanzahl)).toFixed(0);

      return `${this.state.selectedKulissentyp}${this.state.selectedKulissenbreite}-${kulissenspaltbreite}-${this.state.selectedKulissenanzahl}-${this.state.selectedAnschlussprofil}-${this.state.kanalbreite}-${this.state.kanalhoehe}-${this.state.kanallaenge}`;
  }

  getPdfFileName() {
      const pdfFileName = this.state.pdfFileNameManuallyChanged ? this.state.pdfFileName : this.getCurrentBestellschluessel();

      return getPdfDisplayFileName(pdfFileName);
  }

  handlePdfFileNameChange(event) {
      this.setState({
          pdfFileName: getPdfDisplayFileName(event.target.value),
          pdfFileNameManuallyChanged: true,
      });
  }

  handlePdfFileNameKeyDown(event) {
      if (event.key === "Enter") {
          event.preventDefault();
      }
  }

  handleSubmit(event) {
    alert('Kanalbreite: ' + this.state.kanalbreite + '\r' +
        'Volumenstrom: ' +this.state.volumenstrom + ' \r' +
        'Anzahl Kulissen: ' + EingabeAnzahlKulissen.state.value
    );
    event.preventDefault();
  }
  onKeyUp(event) {
      if (event.key === "Enter") {

          if(event.target.value === null || event.target.value === "" ){

          }
          else{
              // console.log("enter " + event.target.value);
              this.handleInputChange(event);
              const form = event.target.form;
              const index = Array.prototype.indexOf.call(form, event.target);
              form.elements[index + 1].focus();
              event.preventDefault();
          }

      }
  }


  render() {
    return (

        <>

            <div className={"form-style-8"}>
                <h2><FormattedMessage id="Eingabe" /></h2>
                <form>

                    <EingabeKulissentyp value={this.state.selectedKulissentyp}  SelectedKulissentyp={this.getSelectedKulissentypHandler} disabledChecked={this.state.optionen[0].isChecked}/>
                    <EingabeKulissenbreite value={this.state.selectedKulissenbreite}  SelectedKulissenbreite={this.getSelectedKulissenbreiteHandler} defaultValue={100}/>


                    <div>
                          <label htmlFor="kanalbreite"><FormattedMessage id="Kanalbreite" /> [mm]{this.state.kanalbreite > 4000 ? <div class='achtung'><strong>max. 4000mm</strong></div> : this.state.kanalbreite <200 ?
                              <div className='achtung'><strong> min. 200mm</strong></div> : ""} </label>
                          <input type="number" id='kanalbreite' min="200" max="4000" name='kanalbreite' defaultValue={this.state.kanalbreite}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>

                    <div>
                          <label htmlFor="kanalhoehe"><FormattedMessage id="Kanalhoehe" /> [mm]{this.state.kanalhoehe > 4000 ?
                              <div className='achtung'><strong>max. 4000mm</strong></div> : this.state.kanalhoehe <200 ? <div className='achtung'><strong> min. 200mm </strong></div> : ""}</label>
                          <input type="number" id='kanalhoehe' min="200" max="4000" name='kanalhoehe' defaultValue={this.state.kanalhoehe}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>
                    <div>
                          <label htmlFor="kanallaenge"><FormattedMessage id="Kanallaenge" /> [mm]{this.state.kanallaenge > 4000 ?
                              <div className='achtung'><strong>max. 4000mm</strong></div> : this.state.kanallaenge <200 ? <div className='achtung'><strong> min. 200mm</strong></div> : ""}</label>
                          <input type="number" id='kanalaenge' min="200" max="4000" name='kanallaenge' defaultValue={this.state.kanallaenge}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>
                    <div>
                        <label htmlFor="volumenstrom"><FormattedMessage id="Volumenstrom" /> [m³/h]{this.state.volumenstrom > 1000000 ? " max. 1000000 m³/h" : this.state.volumenstrom<0 ? " min. 0" : ""}</label>
                        <input type="number" id='volumenstrom' min="0" max="1000000" name='volumenstrom' defaultValue={this.state.volumenstrom}
                               onBlur={this.handleInputChange}
                               onKeyUp={this.onKeyUp}
                               required/>
                    </div>


                    <EingabeAnzahlKulissen value={this.state.selectedKulissenanzahl} kanalbreite={this.state.kanalbreite} kulissenbreite={this.state.selectedKulissenbreite} SelectedKulissenanzahl={this.getSelectedKulissenanzahlHandler} />
                    <EingabeDruckbereich value={this.state.selectedDruckbereich} SelectedDruckbereich={this.getSelectedDruckbereichHandler} />
                    <EingabeAnschlussprofil value={this.state.selectedAnschlussprofil} checked={this.state.checkedAnschlussprofil} SelectedAnschlussprofil={this.getSelectedAnschlussprofilHandler} checkedAnschlussprofil={this.getCheckedAnschlussprofilHandler} calculatedAnschlussprofil={this.state.calculatedAnschlussprofil}/>
                    {/*<input type="submit" value="Submit" />*/}
                    <label><FormattedMessage id='Zusatzoptionen' /> </label>
                    {
                        this.state.optionen.map((optionen) => {
                            return (<EingabeZusatzoptionen handleCheckChieldElement={this.handleCheckChieldElement}  key={optionen.id} id={optionen.id} checked={optionen.isChecked} value={optionen.value} />)
                        })
                    }

                    <div>
                        <label htmlFor="rabatt"><FormattedMessage id='Rabatt' /> [%]</label>
                        <input type="number" id='rabatt' min="0.0" max="100.0" name='rabatt' defaultValue={this.state.rabatt}
                               onBlur={this.handleInputChange}
                               // onKeyUp={this.onKeyUp}
                               required/>
                    </div>
                    <div>
                        <label htmlFor="pdfFileName"><FormattedMessage id='PDF_Dateiname' /></label>
                        <input type="text" id='pdfFileName' name='pdfFileName'
                               value={this.getPdfFileName()}
                               onChange={this.handlePdfFileNameChange}
                               onKeyDown={this.handlePdfFileNameKeyDown}
                               required/>
                    </div>
                </form>
            </div>

            {/*<div className={"form-style-8"}>*/}
            {/*    <h2>Filter</h2>*/}
            {/*    <div className={"resTable"}>*/}
            {/*        <EingabeFilter Filterwerthandler={this.getFilterwertHandler}/>*/}
            {/*    </div>*/}

            {/*</div>*/}
            <div>
                <Schalldaempfer Einfuegedaempfungsdaten={this.state.einfugedaempfung} Schalldaempferbreite={this.state.kanalbreite}
                                Schalldaempferhoehe={this.state.kanalhoehe} Schalldaempferlaenge={this.state.kanallaenge}
                                AnzahlKulissen={this.state.selectedKulissenanzahl} Kulissentyp={this.state.selectedKulissentyp}
                                Kulissenbreite={this.state.selectedKulissenbreite} Druckbereich={this.state.selectedDruckbereich}
                                Volumenstrom={this.state.volumenstrom} CheckedAnschlussprofil={this.state.checkedAnschlussprofil}
                                SelectedAnschlussprofil={this.state.selectedAnschlussprofil}
                                CalculatedAnschlussprofil={this.getCalculatedAnschlussprofilHandler}
                                Filter32hz={this.state.filter32hz}
                                Filter63hz={this.state.filter63hz}
                                Filter125hz={this.state.filter125hz}
                                Filter250hz={this.state.filter250hz}
                                Filter500hz={this.state.filter500hz}
                                Filter1000hz={this.state.filter1000hz}
                                Filter2000hz={this.state.filter2000hz}
                                Filter4000hz={this.state.filter4000hz}
                                Filter8000hz={this.state.filter8000hz}
                                Rabatt={this.state.rabatt}
                                Optionen={this.state.optionen}
                                PdfFileName={this.getPdfFileName()}
                                IsPdfFileNameValid={isValidWindowsPdfFileName(this.getPdfFileName())}
                                currentLocale = {this.props.currentLocale}
                                onCopyShareLink={this.copyShareLink}
                                linkKopiert={this.state.linkKopiert}
                />
            </div>
        </>

    );
  }
}
export default Eingabe;
